import { updateFeatureProperties } from './updateFeatureProperies';
import { TFeature } from '../../types/map';
import { TThunkAction } from '../../types/redux';

export function changeFeatureHover(feature: TFeature, hovered: boolean, isBalloonVisible?: boolean): TThunkAction {
  return (dispatch, getState) => {
    const {
      mapBounds: { precision },
    } = getState();

    dispatch(
      updateFeatureProperties({
        featureId: feature.id,
        precision,
        properties: {
          isHovered: hovered,
          ...(isBalloonVisible === undefined ? {} : { isBalloonVisible }),
        },
      }),
    );
  };
}
